/* tempexp_18086-start */
import Image from 'img/aside-promo-modal/referral/referral-program-space-promo.png';
import React, { type RefObject, useCallback } from 'react';
import { referralProgramBonusQuota } from 'reactApp/appHelpers/featuresHelpers/features/referralProgram';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { ETooltipPlacement, ETooltipSize } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';

import styles from './ReferralProgramSpaceTooltip.css';

interface ReferralProgramSpaceTooltipProps {
    target: RefObject<HTMLDivElement>;
    onClose?(): void;
    onClick?(): void;
    onShow?(): void;
}

export function ReferralProgramSpaceTooltip({ target, onClose, onClick, onShow }: ReferralProgramSpaceTooltipProps) {
    const handleClose = useCallback(() => {
        onClose?.();
    }, [onClose]);

    const handleClick = useCallback(() => {
        onClick?.();
    }, [onClick]);

    const handleShow = useCallback(() => {
        onShow?.();
    }, [onShow]);

    return (
        <FloatingTooltip
            target={target}
            contentClassName={styles.content}
            placement={ETooltipPlacement.rightStart}
            size={ETooltipSize.fit}
            title={`+${referralProgramBonusQuota.value} за друзей — здесь`}
            text={
                <>
                    Рекомендуйте подписку
                    <br />
                    Mail Space и&nbsp;получите по&nbsp;{referralProgramBonusQuota.space}&nbsp;{referralProgramBonusQuota.units}
                </>
            }
            buttonText="Рекомендовать"
            onClose={handleClose}
            onClick={handleClick}
            onShow={handleShow}
            closeOnScroll
            overAll
            usePortal
            closeOnOutsideClick
            isAlternativeButton
            buttonFitContent
            qaId="referral-space-tooltip"
            img={Image}
            imageWidth={107}
        />
    );
}

/* tempexp_18086-end */
